import { PerformanceClient } from "@agoda/performance-client";
import { getAgoda } from "libs/analytics/functions/agoda.homes";
import { messagingClient } from "libs/analytics/functions/messagingClient";
import { getPageTypeId } from "libs/analytics/mappers/pageTypeIdMapper";
import type { Path } from "router";
import { getDevicePlatform } from "./devicePlatformService";

type AddPerformanceInsightInput = {
    userId: string;
    memberId: number;
    pathname: Path;
};

export const sendPerformanceMetric = async (options: Pick<AddPerformanceInsightInput, "pathname">) => {
    const agoda = getAgoda();
    const tags = { appName: "property-onboarding-clientside" };

    const performanceClient = new PerformanceClient({
        messagingClient,
        userId: agoda.userId,
        application: "property-onboarding-clientside",
        page: getPageTypeId(options.pathname) ?? 0,
        whitelabelId: agoda.gtm?.whiteLabelId ?? 1,
        deviceId: agoda.clientProfileDevice,
        osId: agoda.osId,
        clientId: agoda.clientId,
        subclientId: agoda.subClientId,
        device: getDevicePlatform(),
    });

    try {
        await performanceClient.measureAllPerformanceMetrics({ tags });
    } catch (error: unknown) {
        console.error("Error sending performance metrics:", error);
    }
};
